import MsgModal from './MsgModal';

export default MsgModal;
